export default __webpack_public_path__ + "static/media/planimages_84c.c5aff983.png";